import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export enum UserType {
	Presenter,
	Instructor
}

export interface UserTypeSelectionDialogData {
	dialogTitleId?: string;
}

@Component({
	selector: 'user-type-selection-dialog',
	templateUrl: './user-type-selection-dialog.component.html',
	styleUrls: ['./user-type-selection-dialog.component.scss'],
	standalone: false
})
export class UserTypeSelectionDialogComponent {

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<UserTypeSelectionDialogData>
	): MatDialogRef<UserTypeSelectionDialogComponent, UserType | undefined> {
		const dialogTitleId = config?.data?.dialogTitleId ?? UserTypeSelectionDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, UserTypeSelectionDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `user-type-selection-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	constructor (
		private dialogRef: MatDialogRef<UserTypeSelectionDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: UserTypeSelectionDialogData
	) {
		this.data.dialogTitleId ??= UserTypeSelectionDialogComponent.getDialogTitleId();
	}

	public selectInstructor () {
		this.dialogRef.close(UserType.Instructor);
	}

	public selectPresenter () {
		this.dialogRef.close(UserType.Presenter);
	}

	public cancel () {
		this.dialogRef.close();
	}
}
